var map = {
	"./authorize.svg": 2369,
	"./canceled.svg": 2370,
	"./capture.svg": 2371,
	"./card-authentication-line.svg": 2372,
	"./collect-card.svg": 2373,
	"./created.svg": 2374,
	"./failed.svg": 2375,
	"./processing.svg": 2376,
	"./requires-action-line.svg": 2377,
	"./requires-confirmation.svg": 2378,
	"./requires-payment-method.svg": 2379,
	"./succeeded.svg": 2380,
	"./verified.svg": 2381
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2368;